// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/switch/index.css
// module id = 452
// module chunks = 32